import React, { ReactNode, useContext, useEffect, useState } from 'react';

import EventTotalsContext from '@totem/components/services/threats/totals/EventTotalsContext';
import {
  EventSummary,
  EventTotalsInput,
} from '@totem/components/services/threats/totals/types';
import { buildParameters } from '@totem/components/services/threats/totals/utilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { EVENTS_ENDPOINT } from '@totem/utilities/endpoints';
import { omitNilOrEmpty } from '@totem/utilities/objectUtilities';
type Props = {
  regionId?: string[];
  buildingId?: string[];
  controlSystemId?: string[];
  children?: ReactNode;
};
const EventTotalsContainer = ({
  regionId,
  buildingId,
  controlSystemId,
  children,
}: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [input, updateInput] = useState<EventTotalsInput>({
    regionId,
    buildingId,
    controlSystemId,
  });
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<EventSummary>(null);
  const [action, setAction] = useState<string>('');
  const setInput = (updated: Partial<EventTotalsInput>) => {
    updateInput(omitNilOrEmpty({ ...input, ...updated }));

    setRefreshData(true);
  };
  useEffect(() => {
    setRefreshData(true);
  }, [regionId, buildingId, controlSystemId, userProfile.organization.id]);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);
      const uri = `${EVENTS_ENDPOINT}/totals`;
      const payload = buildParameters(regionId, buildingId, controlSystemId);
      fetch(uri, {
        method: 'POST',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result: EventSummary) => {
          setData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [refreshData, getApiToken]);
  const handleAction = (newAction: string) => {
    switch (newAction) {
      case 'refresh':
        setRefreshData(true);

        setAction('');
        break;
      default:
        setAction(newAction);
    }
  };
  return (
    <EventTotalsContext.Provider
      value={{
        input,
        setInput,
        loading: isLoading,
        data,
        action,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </EventTotalsContext.Provider>
  );
};
export default EventTotalsContainer;
